export default "__VITE_ASSET__Hn72LPQL__"